module.exports = __webpack_public_path__ + "static/media/autochilango-headset.f11863f4.svg";